import "./global.css?modules=true";
import React from "react";
import ReactDOM from "react-dom";
import singleSpaReact from "single-spa-react";
import Root from "./root.component";

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
  errorBoundary(err, info, props) {
    // Customize the root error boundary for your microfrontend here.
    return null;
  },
});
export const { bootstrap, mount, unmount } = lifecycles;
export { default as DashboardLayout } from "./DashboardLayout";
export { default as FormLayout } from "./components/FormLayout";
export { default as OrderDetailPage } from "./components/OrderDetailPage";
export { default as Remark } from "./components/Remark";
export { default as TableSettingsLayout} from "./components/TableSettings";
export { default as Sidebar } from "./components/Sidebar";
export { default as useDownload } from "./customHooks/useDownload";
export { default as usePDFPrintHook } from "./customHooks/usePDFPrintHook";
